import React from "react";
import { Controller } from "react-hook-form";
import {
  fieldContainer,
  fieldControlBase,
  fieldControlError,
  fieldErrorText,
  fieldLabel,
} from "./inputTheme";

const CurrencyInput = ({
  className,
  error,
  label,
  name,
  control,
  required = false,
  type = "text",
  readOnly = false,
  disabled = false,
  register,
  ...props
}) => {
  const { onChange: onChangeProp, ...restProps } = props;

  return (
    <div className={`${fieldContainer} ${className || ""}`}>
      {label && (
        <label htmlFor={name} className={fieldLabel}>
          {label}
        </label>
      )}

      <Controller
        control={control}
        name={name}
        rules={{ required }}
        render={({ field: { onChange, onBlur, value, ref } }) => {
          const numericValue = parseFloat(value) || 0;
          const formattedValue =
            value || value === "0"
              ? numericValue.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })
              : "";

          const handleChange = (e) => {
            const inputValue = e.target.value;
            const digits = inputValue.replace(/\D/g, "");
            if (digits === "") {
              onChange("");
              return;
            }
            const parsed = parseFloat(digits) / 100;
            // Passa para o formulário o valor limpo com ponto como separador
            onChange(parsed.toFixed(2));
          };

          return (
            <>
              <input
                type={type}
                id={name}
                name={name}
                ref={ref}
                value={formattedValue}
                onChange={(e) => {
                  handleChange(e);
                  if (onChangeProp) onChangeProp(e);
                }}
                onBlur={onBlur}
                readOnly={readOnly}
                disabled={disabled}
                placeholder=""
                className={`${fieldControlBase} ${error ? fieldControlError : ""}`}
                {...restProps}
              />
            </>
          );
        }}
      />
      {error && <small className={fieldErrorText}>{error}</small>}
    </div>
  );
};

export default CurrencyInput;
